import { IPlaylistIconProps } from "interfaces";

const PlayListIcon = ({ className }: IPlaylistIconProps) => {
    return (
        <svg width="22" height="14" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path d="M20.75 1.5H0.75C0.34 1.5 0 1.16 0 0.75C0 0.34 0.34 0 0.75 0H20.75C21.16 0 21.5 0.34 21.5 0.75C21.5 1.16 21.16 1.5 20.75 1.5Z" />
            <path d="M9.75 7.5H0.75C0.34 7.5 0 7.16 0 6.75C0 6.34 0.34 6 0.75 6H9.75C10.16 6 10.5 6.34 10.5 6.75C10.5 7.16 10.16 7.5 9.75 7.5Z" />
            <path d="M6.75 13.5H0.75C0.34 13.5 0 13.16 0 12.75C0 12.34 0.34 12 0.75 12H6.75C7.16 12 7.5 12.34 7.5 12.75C7.5 13.16 7.16 13.5 6.75 13.5Z" />
            <path d="M13.75 6.31676V12.1841C13.75 13.3857 15.0212 14.1398 16.0357 13.539L18.5124 12.0737L20.9891 10.6023C22.0036 10.0014 22.0036 8.49937 20.9891 7.89854L18.5124 6.42712L16.0357 4.96183C15.0212 4.361 13.75 5.10897 13.75 6.31676Z" />
        </svg>
    );
};

export default PlayListIcon;
